module.exports = __webpack_public_path__ + "img/testimonial-3.30472b10.jpeg";